<template>
    <div class="container index-main">
      <div class="im-swiper" v-if="indexInfo.bannerList.length > 0">
        <el-carousel height="600px" motion-blur>
          <el-carousel-item>
            <div class="item-block">
              <img :src="indexInfo.bannerList[0].bannerUrl" alt="">
              <div class="ib-dw active">
                <div class="title">Changbaishan</div>
                <div class="desc">Humid climate、fertile soil、 forest cover</div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item v-if="indexInfo.bannerList.length > 1">
            <div class="item-block">
              <img :src="indexInfo.bannerList[1].bannerUrl" alt="">
              <div class="ib-dw">
                <div class="title">Forest Ginseng</div>
                <div class="desc">The victory is in Changbaishan.</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="im-subTitle divFlex">
        <div class="list">
          <div class="middle">01.</div>
          <div class="middle">
            <p>CHOOSE PRODUCTS</p>
            <span>Select the ginseng you want to buy from "CC-Ginseng".</span>
          </div>
        </div>
        <div class="list">
          <div class="middle">02.</div>
          <div class="middle">
            <p>CHOOSE PRODUCTS</p>
            <span>Select the ginseng you want to buy from "CC-Ginseng".</span>
          </div>
        </div>
        <div class="list">
          <div class="middle">03.</div>
          <div class="middle">
            <p>CHOOSE PRODUCTS</p>
            <span>Select the ginseng you want to buy from "CC-Ginseng".</span>
          </div>
        </div>
      </div>
      <div class="im-product">
        <div class="imp-title divFlex">
          <div>TRENDING PRODUCTS</div>
          <span>VIEW ALL PRODUCTS</span>
        </div>
        <div class="imp-body">
          <goods-list :list="indexInfo.goodsLike"/>
        </div>
      </div>
    </div>
</template>

<script setup>
import API from '@/utils/request';
import {reactive, onMounted, defineComponent, watch} from 'vue';
import router from '@/router/index';
import goodsList from '@/components/goodsList.vue';
import {useStore} from "vuex";

const store = useStore()
defineComponent({
  components: {
    goodsList
  }
})

const indexInfo = reactive({
    bannerList: [],
    goodsLike: [],
    goodsHot: []
})


// 轮播图获取方法
function bannerGet() {
    API.getRequest("tea/banner/list",{},(res) => {
        indexInfo.bannerList = res.data
    })
}
/**
 * 
 * @param {*} _type goodsType 0 飞天茅台酒 1 茅台年份酒 2 茅台定制酒
 * @param {*} _category goodsCategory 0 人气专区 1 热推产品 2 猜你喜欢
 */
function goodsListGet(_type, _category) {
    let obj = {}
    if(_type) {
        obj.goodsType = _type
    }
    if(_category) {
        obj.goodsCategory = _category
    }
    API.getRequest("tea/goods/list",obj,(res) => {
        if(_category == '1') {
            indexInfo.goodsHot = res.data
        }
        if(_category == '0') {
            indexInfo.goodsLike = res.data
        }
    })
}



onMounted(() => {
    bannerGet()
    // goodsListGet("", "1")
    goodsListGet("", "0")
})
</script>

<style scoped lang="scss">
.index-main{
  .im-swiper{
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    .is-active{
      .item-block{
        .ib-dw{
          left: 15px;
        }
      }
    }
    .item-block{
      position: relative;
      width: 100%;
      height: 600px;
      >img{
        width: 100%;
        height: 600px;
      }
      .ib-dw{
        position: absolute;
        left: -100%;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        transition: all .5s linear;
        &.active{
          .title{
            color: #FFFFFF;
            text-shadow: 16px 0px 12px rgba(2.3799896240234135, 0.025869452435037216, 0.025869452435037216, 0.99);
          }
          .desc{
            color: #FFFFFF;
            text-shadow: 16px 0px 12px rgba(2.3799896240234135, 0.025869452435037216, 0.025869452435037216, 0.99);
          }
        }
        .title{
          font-size: 64px;
          line-height: 76px;
          margin-bottom: 20px;
        }
        .desc{
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
  }
  .im-subTitle{
    padding: 50px 0;
    border-bottom: 1px solid rgba(129, 129, 129, 0.2);
    .list{
      width: 33.33%;
      padding-right: 2%;
      >div{
        &:first-child{
          font-size: 74px;
          color: rgb(221,153,51);
          width: 122px;
        }
        &:last-child{
          width: calc(100% - 122px);
          p{
            font-size: 16px;
            color: #242424;
            margin-bottom: 10px;
          }
          span{}
        }
      }
    }
  }
  .im-product{
    padding-top: 50px;
    .imp-title{
      margin-bottom: 20px;
      color: #242424;
      div{
        font-size: 26px;
        font-weight: 600;
        padding-bottom: 10px;
        position: relative;
        &::after{
          content: " ";
          position: absolute;
          top: 100%;
          left: 0;
          width: 40px;
          height: 2px;
          background-color: rgb(221, 153, 51);
        }
      }
      span{
        color: #333;
        border-bottom: 1px solid rgb(221, 153, 51);
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .index-main{
    .im-swiper{
      .title{
        font-size: 34px !important;
      }
      .desc{
        display: none;
      }
      .item-block{
        >img{
          position: absolute;
          left: 50%;
          top: 50%;
          height: 100%;
          width: auto;
          transform: translate(-50%,-50%);
          -webkit-transform: translate(-50%,-50%);
        }
      }
    }
    .im-subTitle{
      flex-direction: column;
      .list{
        width: 100%;
        >div{
          &:first-child{
            font-size: 52px;
            width: 90px;
          }
        }
      }
    }
    .im-product{
      .imp-title{
        div{
          font-size: 22px;
        }
        span{
          display: none;
        }
      }
    }
  }
}

</style>